import React from "react";
import MeditationType from "./MeditationType";
import SymptomSelector from "./SymptomSelector";
import {
  emotionalSymptoms,
  meditationTypes,
} from "../../data/meditationSymptoms";

const getTimestamp = () => new Date().toISOString();

const MeditationTracker = ({ logEntry, onChange, isVisible }) => {
  if (!isVisible) {
    return null;
  }

  const handleChange = (field, value) => {
    onChange({
      ...logEntry,
      [field]: value,
      Timestamp: logEntry.Timestamp || getTimestamp(),
    });
  };

  const getWarningsFromDetails = (details) => {
    if (!details || typeof details !== "string") return [];
    const text = details.toLowerCase();
    return Triggers.filter((entry) =>
      entry.sources?.some((keyword) => {
        if (!text.includes(keyword)) return false;
        // If this entry has exclusions, ensure none are present
        if (entry.exclusions) {
          return !entry.exclusions.some((ex) => text.includes(ex));
        }
        return true;
      })
    );
  };

  return (
    <div className="tw-px-4 tw-mb-2">
      <MeditationType
        label="Meditation Type"
        categories={meditationTypes}
        selected={logEntry["Meditation Type"] || ""}
        setSelected={(val) => handleChange("Meditation Type", val)}
      />

      <div className="tw-flex tw-gap-4">
        <div className="tw-mb-1 tw-flex-1">
          <SymptomSelector
            label="Mood Before"
            categories={emotionalSymptoms}
            selected={logEntry["Mood Before"] || ""}
            setSelected={(val) => handleChange("Mood Before", val)}
          />
        </div>
        <div className="tw-mb-1 tw-flex-1">
          <SymptomSelector
            label="Mood After"
            categories={emotionalSymptoms}
            selected={logEntry["Mood After"] || ""}
            setSelected={(val) => handleChange("Mood After", val)}
          />
        </div>
      </div>
      <div className="tw-mb-6">
        <div className="tw-w-full">
          <label className="tw-block tw-mb-2 tw-w-full">
            Main Thought or Insight{" "}
          </label>
        </div>
        <textarea
          value={logEntry["Main Insight"] || ""}
          onChange={(e) => handleChange("Main Insight", e.target.value)}
          className="tw-w-full tw-border tw-rounded-lg tw-p-4 dark:tw-bg-black"
          rows={2}
        />
      </div>
    </div>
  );
};

export default MeditationTracker;
